export default __webpack_public_path__ + "static/media/Sielanka_60.bd2fc484.jpg";